import { useShareToken } from '../hooks/useShareToken';
import { useFirebaseDoc } from '../hooks/firebaseHooks';
import { Offer } from '../models/shared/Offer';
import { COLLECTIONS } from '../utils/shared/constants';
import { Container, FormControl } from 'react-bootstrap';
import Block from '../components/offers/Block';
import { Deal } from '../models/shared/Deal';
import { UnAuthOrganizationContextProvider } from '../context/OrganizationContext';
import { useEffect, useRef, useState } from 'react';
import { actionOffer } from '../utils/api';
import { OfferAuditRecordType } from '../models/shared/OfferAuditRecord';
import { useSigninCheck } from 'reactfire';
import OfferLog from '../components/offers/OfferLog';
import { AdvancedButton } from '../components/AdvancedButton';
import { useText } from '../context/TextContext';
import { toast } from 'react-toastify';
import LoadingPage from './LoadingPage';


export default function OfferPage() {
    const { token, organization, loading, tokenId } = useShareToken();
    const { status: signInStatus, data: signInCheckResult } = useSigninCheck();
    const [processing, setProcessing] = useState(false);
    const text = useText();
    const [commentText, setCommentText] = useState<string>('');
    const [showComment, setShowComment] = useState(false);
    const commentTextRef = useRef<HTMLTextAreaElement>(null);

    const [offer] = useFirebaseDoc<Offer>(token && `${COLLECTIONS.ORGANIZATIONS}/${token?.orgId || ''}/${COLLECTIONS.DEALS}/${token?.dealId || ''}/${COLLECTIONS.OFFERS}/${token?.offerId || ''}`);
    const [deal] = useFirebaseDoc<Deal>(token && `${COLLECTIONS.ORGANIZATIONS}/${token?.orgId}/${COLLECTIONS.DEALS}/${token?.dealId}`)

    console.log('offer', offer);

    useEffect(() => {
        if (!tokenId || signInStatus === 'loading') return;

        if (signInCheckResult?.signedIn) return;

        actionOffer(tokenId, OfferAuditRecordType.Visited)
    }, [tokenId, signInCheckResult?.signedIn, signInStatus]);

    if (!deal || !tokenId || !offer || loading || !organization) {
        return <LoadingPage />
    }

    const handleActionOffer = async (type: OfferAuditRecordType) => {
        setProcessing(true);
        try {
            await actionOffer(tokenId, type, commentText.trim() || '');
            setCommentText('');
            toast.success(type === OfferAuditRecordType.Accepted ? text.offerAccepted : text.defaultSuccess);
        } catch (e) {
            console.error('Error accepting offer', e);
            toast.error(text.defaultError);
        } finally {
            setProcessing(false);
        }
    }

    const handleComment = () => {
        if (showComment) {
            handleActionOffer(OfferAuditRecordType.Comment);
        } else {
            setShowComment(true);
            if (commentTextRef.current) {
                commentTextRef.current.focus();
            }
        }
    }

    const textCommentRows = Math.max(3, Math.min(10, commentText.split('\n').length));

    const textCommentArea = commentTextRef.current?.scrollHeight || 0;
    return (
        <UnAuthOrganizationContextProvider organization={organization} orgId={token?.orgId || ''}>
            <div className='bg-body'>

                <div className='bg-offer position-relative' >
                    <Container className="d-flex flex-column pt-5 pb-5">

                        {offer?.blocks?.map((_, ix) => {

                            return <Block
                                key={ix}
                                readOnly
                                ix={ix}
                                offer={offer}
                                deal={deal}
                                onOfferUpdate={() => { }}
                            />


                        })}

                    </Container>
                </div>
                {offer.acceptedAt
                    ? <div className='py-2' />
                    : <div className='d-flex flex-column gap-3 py-4 bg-offer-footer position-sticky bottom-0'>
                        <Container>

                            <div className='animate overflow-hidden '
                                style={{ maxHeight: showComment ? textCommentArea + 10 : '0px' }}
                            >

                                <FormControl as="textarea" value={commentText} onChange={e => setCommentText(e.target.value)}
                                    ref={commentTextRef}
                                    rows={textCommentRows}
                                />
                            </div>

                            <div className='d-flex justify-content-end gap-2'>
                                <AdvancedButton
                                    icon='bi-chat-left-text'
                                    variant='secondary'
                                    processing={processing}
                                    onClick={handleComment}
                                >{text.comment}</AdvancedButton>
                                <AdvancedButton
                                    icon='bi-check2'
                                    variant='success'
                                    processing={processing}
                                    onClick={() => handleActionOffer(OfferAuditRecordType.Accepted)}
                                >{text.acceptOffer}</AdvancedButton>
                            </div>
                        </Container>
                    </div>
                }
                <Container>
                    <OfferLog offer={offer} hideOpens className='mt-2' />
                </Container>
            </div>
        </UnAuthOrganizationContextProvider>
    )
}
